import SkapaTabs from "@coworker/app/src/components/InputPopup/SkapaTabs";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { TasksTabs } from "../../constants/tasksTabs";
import { TasksOverviewTabType } from "../../hooks/useTasksOverviewTabs";

interface TasksOverviewTabsProps {
  tabs: TasksOverviewTabType[];
  activeTab: TasksTabs;
  onTabChange: (tab: TasksTabs) => void;
}

export const TasksOverviewTabs = ({
  tabs,
  activeTab,
  onTabChange,
}: TasksOverviewTabsProps) => {
  const tabChangedHandler = (tabKey: TasksTabs) => {
    onTabChange(tabKey);
    trackerHelper.trackActivityTabClick(tabKey);
  };

  return (
    <SkapaTabs
      tabs={tabs}
      active={activeTab}
      onTabChanged={tabChangedHandler}
      noTabPanelPadding
    />
  );
};
